import React, { useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { ReactSVG } from 'react-svg';

import { Colors } from '../../../../scss/common/style';

interface Props {
  title: string;
  isDisabled?: boolean;
  link: string;
  icon?: any;
}

export default function SecondaryTabButton({ link, title, isDisabled = true, icon }: Props): JSX.Element {
  return (
    <SecondaryNavigationLink to={link} onClick={isDisabled ? (e) => e.preventDefault() : null}>
      {icon && <StyledImg src={icon} alt={icon} />}
      <span>{title}</span>
    </SecondaryNavigationLink>
  );
}

const StyledImg = styled(ReactSVG)`
  height: 25px;
  width: 25px;
  svg {
    height: 25px;
    width: 25px;
  }
  margin-right: 5px;
`;

const SecondaryNavigationLink = styled(Link)`
  margin: 5px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  background-color: #fbfbfb;
  border: 1px solid #eeeeee;
  border-radius: 100px;
  color: ${Colors.darkBrown};
  height: 35px;
  padding: 5px 12px;
  width: auto;
  &:hover {
    background-color: #eeeeee;
    color: ${Colors.darkBrown};
    text-decoration: none;
  }
  &:active {
    background-color: ${Colors.darkBrown};
    border: 1px solid ${Colors.darkBrown};
    color: #fff;
    svg path {
      stroke: #fff;
    }
  }
`;
